import { render, staticRenderFns } from "./messaging.vue?vue&type=template&id=d3a34c64"
import script from "./messaging.vue?vue&type=script&lang=js"
export * from "./messaging.vue?vue&type=script&lang=js"
import style1 from "./messaging.vue?vue&type=style&index=1&id=d3a34c64&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports